
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const LeftPanel = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <polygon points="11.6 18.6 5.4 12.5 11.6 6.4 12.6 7.4 7.6 12.5 12.6 17.6 11.6 18.6"></polygon>
          <polygon points="18 18.6 11.8 12.5 18 6.4 19 7.4 14 12.5 19 17.6 18 18.6"></polygon>
        </g>
      </g>
    </IconBase>);
};

LeftPanel.defaultProps = {
  title: 'Left Panel',
};

export default LeftPanel;
